





















































































































































import { Component, Vue, Inject, Prop } from "vue-property-decorator";
import Util from "../../../lib/util";
import AbpBase from "../../../lib/abpbase";
import PageRequest from "@/store/entities/page-request";
import ListMixin from "@/components/mixin/list-mixin";
import { mixins } from "vue-class-component";
import _ from "lodash";
import DateTimeMixin from "@/components/mixin/date-time-mixin";
import AppConsts from "../../../lib/appconst";

class PagePickListRequest extends PageRequest {
  productId: number;
  soId: number;
  pageSize: number;
  pageNum: number;
}
@Component
export default class SoLineProductInfoModal extends mixins(
  DateTimeMixin,
  AbpBase
) {
  @Prop({ type: Boolean, default: false }) value: boolean;
  @Prop({ type: Number, default: 0 }) salesOrderId: number;
  @Prop({ type: Number, default: 0 }) productId: number;
  @Prop({ type: Number, default: 0 }) salesOrderLineId: number;

  namespace = "soLinePickList";
  plPageRequest: PagePickListRequest = new PagePickListRequest();
  spinShow: boolean = false;
  pickList = [];
  pagingPl = [];
  get plStore() {
    return this.$store.state.soLinePickList;
  }
  get soLineInfo() {
    return this.plStore.soLineInfo;
  }
  get totalAllocatingQty() {
    return _.isNil(this.soLineInfo) ? 0 : this.soLineInfo.totalAllocatingQty;
  }
  get totalPickedQty() {
    return _.isNil(this.soLineInfo) ? 0 : this.soLineInfo.totalPickedQty;
  }
  get totalRepickedQty() {
    return _.isNil(this.soLineInfo) ? 0 : this.soLineInfo.totalRepickedQty;
  }
  get totalConfirmPickingQty() {
    return _.isNil(this.soLineInfo)
      ? 0
      : this.soLineInfo.totalConfirmPickingQty;
  }
  get totalPackedQty() {
    return _.isNil(this.soLineInfo) ? 0 : this.soLineInfo.totalPackedQty;
  }
  get totalConfirmPackingQty() {
    return _.isNil(this.soLineInfo)
      ? 0
      : this.soLineInfo.totalConfirmPackingQty;
  }
  //==========PickList

  get plLoading() {
    return this.plStore.loading;
  }
  plPageChange(page: number) {
    this.$store.commit(`${this.namespace}/setCurrentPage`, page);
    this.getplpage();
  }

  plPagesizeChange(pagesize: number) {
    this.$store.commit(`${this.namespace}/setPageSize`, pagesize);
    this.getplpage();
  }
  async searchPl() {
    this.plPageChange(1);
  }
  getplpage() {
    this.pagingPl = Util.pagingItems(
      this.pickList,
      this.plPageSize,
      this.plCurrentPage
    );
    //filters
  }
  get plPageSize() {
    return this.plStore.pageSize;
  }
  get plTotalCount() {
    return this.plStore.totalCount;
  }
  get plCurrentPage() {
    return this.plStore.currentPage;
  }
  async visibleChange(value: boolean) {
    if (!value) {
      this.$emit("input", value);
    } else {
      this.spinShow = true;
      this.$store
        .dispatch({
          type: `${this.namespace}/getAll`,
          data: {
            soId: this.salesOrderId,
            productId: this.productId,
          },
        })
        .then((re) => {
          this.pickList = this.buildPlList(re);
        })
        .finally(() => {
          this.getplpage();
          this.spinShow = false;
        })
        .catch((error) => {});
    }
  }
  async created() {}
  buildPlList(items) {
    var re = items;
    var startIndex = 0;
    var index = 0;
    re.forEach(function(item) {
      item.orderNo = startIndex + index + 1;
      index++;
    });
    return re;
  }
  cancel() {
    this.reset();
    (this.$refs.soLinePickListForm as any).resetFields();
    this.$emit("input", false);
  }
  reset() {
    this.plPageRequest = new PagePickListRequest();
    this.pickList = [];
    this.pagingPl = [];
    this.$store.commit(`${this.namespace}/resetSoLineInfoData`);
  }
  showEdit(row: any) {
    if (row.showEdit === false) {
      row.showEdit = true;
    }
  }
  validEditingConfirmPickingQtyStatus() {
    return _.isNil(this.soLineInfo)
      ? false
      : this.soLineInfo.soStatusCode === AppConsts.soStatus.picking ||
          this.soLineInfo.soStatusCode === AppConsts.soStatus.picked_par;
  }
  validEditingConfirmPackingQtyStatus() {
    return _.isNil(this.soLineInfo)
      ? false
      : this.soLineInfo.soStatusCode === AppConsts.soStatus.packing;
  }
  enableSaveButton() {
    return (
      (this.hasEditConfirmPickingQtyPermission() ||
        this.hasEditConfirmPackingQtyPermission()) &&
      _.some(
        this.pickList,
        (i) =>
          i.confirmPickingQty !== i.newConfirmPickingQty ||
          i.confirmPackingQty !== i.newConfirmPackingQty
      )
    );
  }
  hasEditConfirmPickingQtyPermission() {
    return (
      this.hasPermission("Operations.SalesOrders.AdjustConfirmPickingQty") &&
      this.validEditingConfirmPickingQtyStatus()
    );
  }
  hasEditRowConfirmPickingQtyPermission(row) {
    return (
      this.hasEditConfirmPickingQtyPermission() &&
      row.locationStatusCode === "PICKED_PAR"
    );
  }
  hasEditConfirmPackingQtyPermission() {
    return (
      this.hasPermission("Operations.SalesOrders.AdjustConfirmPackingQty") &&
      this.validEditingConfirmPackingQtyStatus()
    );
  }
  hasEditRowConfirmPackingQtyPermission(row) {
    return (
      this.hasEditConfirmPackingQtyPermission() &&
      row.locationStatusCode === "PACKING"
    );
  }
  checkEditConfirmPickingQty(row: any, index: number) {
    var editQty = row.newConfirmPickingQty;
    if (editQty > row.pickedQty + row.repickedQty) {
      editQty = row.pickedQty + row.repickedQty;
    }
    row.newConfirmPickingQty = editQty;
    this.pagingPl[index].showEdit = row.showEdit;
    this.pagingPl[index].newConfirmPickingQty = editQty;
    var lineIndex = _.findIndex(this.pickList, {
      pickListId: row.pickListId,
    });
    if (_.isNil(lineIndex) && lineIndex >= 0) {
      this.pickList[lineIndex].newConfirmPickingQty = editQty;
    }
  }
  checkEditConfirmPackingQty(row: any, index: number) {
    var editQty = row.newConfirmPackingQty;
    if (editQty > row.pickedQty + row.repickedQty) {
      editQty = row.pickedQty + row.repickedQty;
    }
    row.newConfirmPackingQty = editQty;
    this.pagingPl[index].showEdit = row.showEdit;
    this.pagingPl[index].newConfirmPackingQty = editQty;
    var lineIndex = _.findIndex(this.pickList, {
      pickListId: row.pickListId,
    });
    if (_.isNil(lineIndex) && lineIndex >= 0) {
      this.pickList[lineIndex].newConfirmPackingQty = editQty;
    }
  }

  getDataToSaveConfirmQty() {
    if (this.soLineInfo.soStatusCode === AppConsts.soStatus.packing) {
      var packingItems = this.pickList.map(function(i) {
        return {
          PickListId: i.pickListId,
          ConfirmPackingQty: i.confirmPackingQty,
          NewConfirmPackingQty: i.newConfirmPackingQty,
        };
      });
      return {
        soId: this.salesOrderId,
        Sku: this.soLineInfo.sku,
        SoLineId: this.salesOrderLineId,
        ProductId: this.productId,
        items: packingItems,
      };
    } else {
      var pickingItems = this.pickList.map(function(i) {
        return {
          PickListId: i.pickListId,
          ConfirmPickingQty: i.confirmPickingQty,
          NewConfirmPickingQty: i.newConfirmPickingQty,
        };
      });
      return {
        soId: this.salesOrderId,
        Sku: this.soLineInfo.sku,
        SoLineId: this.salesOrderLineId,
        ProductId: this.productId,
        items: pickingItems,
      };
    }
  }
  async save() {
    this.$Modal.confirm({
      title: this.L("Tips"),
      content: this.L("Confirm.AdjustSoConfirmQty"),
      okText: this.L("Yes"),
      cancelText: this.L("No"),
      onOk: async () => {
        var data = this.getDataToSaveConfirmQty();
        var functionName =
          this.soLineInfo.soStatusCode === AppConsts.soStatus.packing
            ? "adjustConfirmPackingQty"
            : "adjustConfirmPickingQty";
        this.spinShow = true;
        this.$store
          .dispatch({
            type: `${this.namespace}/${functionName}`,
            data: data,
          })
          .then(() => {
            Util.showSuccessMsg(this, "Success.AdjustSoConfirmQty");
            this.reset();
            (this.$refs.soLinePickListForm as any).resetFields();
            this.$emit("save-success");
            this.$emit("input", false);
          })
          .finally(() => {
            this.spinShow = false;
          });
      },
    });
  }
  get plColumns() {
    return [
      {
        title: this.L("Order"),
        width: 60,
        key: "orderNo",
      },
      {
        title: Util.L("Code"),
        width: 200,
        key: "pickListCode",
      },
      {
        title: Util.L("Status"),
        width: 150,
        key: "statusName",
      },
      {
        title: `${Util.L("AllocatingQty")} (${Util.toViewNumberString(
          this.totalAllocatingQty
        )})`,
        key: "allocatingQty",
        width: 80,
        align: "right",
        render: (h: any, params: any) => {
          return h("span", Util.toViewNumberString(params.row.allocatingQty));
        },
      },
      {
        title: `${Util.L("PickedQty")} (${Util.toViewNumberString(
          this.totalPickedQty
        )})`,
        key: "pickedQty",
        width: 80,
        align: "right",
        render: (h: any, params: any) => {
          return h("span", Util.toViewNumberString(params.row.pickedQty));
        },
      },
      {
        title: `${Util.L("RepickedQty")} (${Util.toViewNumberString(
          this.totalRepickedQty
        )})`,
        key: "repickedQty",
        width: 80,
        align: "right",
        render: (h: any, params: any) => {
          return h("span", Util.toViewNumberString(params.row.repickedQty));
        },
      },
      {
        title: `${Util.L("AdjustConfirmPickingQty")} (${Util.toViewNumberString(
          this.totalConfirmPickingQty
        )})`,
        slot: "confirmPickingQty",
        width: 150,
        align: "right",
      },
      {
        title: `${Util.L("PackedQty")} (${Util.toViewNumberString(
          this.totalPackedQty
        )})`,
        key: "packedQty",
        width: 80,
        align: "right",
        render: (h: any, params: any) => {
          return h("span", Util.toViewNumberString(params.row.packedQty));
        },
      },
      {
        title: `${Util.L("AdjustConfirmPackingQty")} (${Util.toViewNumberString(
          this.totalConfirmPackingQty
        )})`,
        slot: "confirmPackingQty",
        width: 150,
        align: "right",
      },
      {
        title: Util.L("Transport"),
        width: 150,
        key: "locationCode",
      },
      {
        title: Util.L("TransportStatus"),
        width: 150,
        key: "locationStatusName",
      },
      {
        title: Util.L("Employee"),
        width: 150,
        key: "employeeId",
        render: (h: any, params: any) => {
          return h(
            "span",
            `${params.row.userName} - ${params.row.userFullName}`
          );
        },
      },
      {
        title: Util.L("CreationTime"),
        key: "creationTime",
        width: 170,
        render: (h: any, params: any) => {
          return h("span", Util.toViewDateString(params.row.creationTime));
        },
      },
    ];
  }
}
